import { motion } from "framer-motion";

const YES = [
  "You're tired of chasing realtor referrals that never come",
  "You want a lead source you actually own and control",
  "You're willing to run $500–$1,500/month in Meta ads",
  "You're serious about niching down (VA, FHA, USDA, DSCR, etc.)",
  "You want a system, not a hope",
];

const NO = [
  "You want leads handed to you with zero effort on your part",
  "You're not willing to show up on a webinar",
  "You're not licensed in a state where Meta ads can reach your audience",
  "You need results tomorrow (this is a 30–90 day build)",
];

export default function WhoFor() {
  return (
    <section
      className="relative py-32 md:py-48"
      data-testid="whofor-section"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.9 }}
          >
            <div className="font-mono text-[11px] tracking-[0.3em] text-[#C9A84C] mb-6">
              THIS IS FOR YOU IF...
            </div>
            <ul className="space-y-5">
              {YES.map((y, i) => (
                <motion.li
                  key={y}
                  initial={{ opacity: 0, x: -12 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{ duration: 0.6, delay: i * 0.08 }}
                  className="flex items-start gap-4 border-t wam-hairline pt-5"
                >
                  <span className="text-[#C9A84C] font-display text-[20px] leading-none">
                    ✓
                  </span>
                  <span className="font-body text-[15px] leading-[1.6] text-[#F0ECE4]/85">
                    {y}
                  </span>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.9, delay: 0.15 }}
          >
            <div className="font-mono text-[11px] tracking-[0.3em] text-[#F0ECE4]/40 mb-6">
              THIS IS NOT FOR YOU IF...
            </div>
            <ul className="space-y-5">
              {NO.map((n, i) => (
                <motion.li
                  key={n}
                  initial={{ opacity: 0, x: 12 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{ duration: 0.6, delay: i * 0.08 }}
                  className="flex items-start gap-4 border-t wam-hairline pt-5"
                >
                  <span className="text-[#E05252]/70 font-display text-[20px] leading-none">
                    ✗
                  </span>
                  <span className="font-body text-[15px] leading-[1.6] text-[#F0ECE4]/50">
                    {n}
                  </span>
                </motion.li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
